import { serverTimestamp } from "firebase/firestore";
import { ContactForm } from "../redux/contact";
import { Store, STORES } from "./store";

export const addContactUs = async (data: ContactForm) => {
    try {
        const result = await Store.insert(STORES.CONTACT, { ...data, status: "PENDING", timeStamp: serverTimestamp() });
        return result;
    } catch (error) {
        return null;
    }
};
